import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import { mapState } from 'vuex';
export default {
  name: 'LineBarChartOptionsEditor',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    lineChartSmooth: {
      get() {
        return this.getByKey('chartOptions.lineChart.smooth', false);
      },
      set(val) {
        this.setByKey('chartOptions.lineChart.smooth', val, 'boolean');
      }
    },
    yAxisMin() {
      return this.getByKey('chartOptions.yAxisMin', 'auto');
    },
    yAxisMax() {
      return this.getByKey('chartOptions.yAxisMax', 'auto');
    },
    axisMinMaxItems() {
      const options = ['auto', 'auto-cropped'];
      return options.map(option => ({
        text: this.$t(`Dashboards.components.widgetChartOptionsEditor.inputs.yAxisMinMax.options.${option}`),
        value: option
      }));
    }
  },
  methods: {
    getByKey(key, defaultValue = undefined) {
      return get(this.value, key, defaultValue);
    },
    setByKey(key, val, transformTo = undefined) {
      if (transformTo === 'number') {
        if (val === undefined) {
          val = null;
        }
        if (val !== null) {
          val = Number(val);
        }
      }
      if (transformTo === 'boolean') {
        val = !!val;
      }
      const clone = cloneDeep(this.value);
      set(clone, key, val);
      this.$emit('input', clone);
    },
    setYAxisMinMax(minOrMax, val) {
      if (typeof val !== 'string') {
        val = val.value;
      } else {
        val = Number(val);
      }
      const axisName = minOrMax.toLowerCase().split('').map((char, cIndex) => {
        if (cIndex === 0) {
          return char.toUpperCase();
        }
        return char;
      }).join('');
      this.setByKey(`chartOptions.yAxis${axisName}`, val, 'string');
    }
  }
};